/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import flatten from "lodash/flatten";
import groupBy from "lodash/groupBy";
import map from "lodash/map";

import { IComboBoxOption, SelectableOptionMenuItemType } from "@fluentui/react";

import { IActivityEventTypesDataState } from "Interfaces/SiteContent/IActivityEventTypesDataState";

export const getActivityEventTypesOptionsList = (
  state: IActivityEventTypesDataState
): IComboBoxOption[] => {
  const activityEventTypes = map(
    groupBy(state.activityEventTypesData, "activityOrEvent"),
    (value, key) => {
      const header = {
        text: key,
        key: key,
        itemType: SelectableOptionMenuItemType.Header,
      };

      const group = value.map((at) => {
        return {
          text: at.name,
          key: at.name,
          itemType: SelectableOptionMenuItemType.Normal,
        };
      });

      const divider = {
        key: "divider",
        text: "-",
        itemType: SelectableOptionMenuItemType.Divider,
      };
      return [header, ...group, divider];
    }
  );

  return flatten(activityEventTypes);
};

export const getActivityEventTypesLoadError = (
  state: IActivityEventTypesDataState
): string | undefined => state.errorMessage;
